export const getPropertyType = (propCategory) => {
  const propertyTypeMap = {
    // String codes
    SC: "Second Chance",
    REO: "REO",
    FORECLOSURE: "Foreclosure",
    COMMERCIAL: "Commercial",
    SHRT_SALE: "Short Sale",
    NON_REO: "Non Reo",
    ABS: "Absolute",
    NPL: "NPL",
    // Numeric IDs
    1: "REO",
    2: "Short Sale",
    3: "Non Reo",
    4: "Foreclosure",
    5: "Second Chance",
    6: "Absolute",
    7: "NPL",
    8: "Commercial",
  };
  return propertyTypeMap[propCategory] || propCategory || "";
};
